import { render, staticRenderFns } from "./TopTopics.vue?vue&type=template&id=05957c88&scoped=true"
import script from "./TopTopics.vue?vue&type=script&lang=js"
export * from "./TopTopics.vue?vue&type=script&lang=js"
import style0 from "./TopTopics.vue?vue&type=style&index=0&id=05957c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05957c88",
  null
  
)

export default component.exports